import axios, { AxiosError } from "axios";
import { store } from "store";
import { logOut } from "store/auth";
import { trackException } from "hooks/useGATracking";

axios.interceptors.request.use((request) => {
  const { userToken } = store.getState().authState;
  if (userToken) {
    request.headers.Authorization = `Bearer ${userToken}`;
  }

  return request;
});

axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    // Track API errors in GA4 for BigQuery crash/error analysis
    const status = error?.response?.status;
    const rawUrl = error?.config?.url || "unknown";
    const url = (() => {
      try {
        return new URL(rawUrl).pathname;
      } catch {
        return rawUrl.split("?")[0].split("#")[0];
      }
    })();
    if (status && status >= 400) {
      trackException(
        `API ${status}: ${error?.config?.method?.toUpperCase()} ${url}`,
        status >= 500
      );
    }

    if (error.response && error.response.status === 403) {
      return Promise.reject(new AxiosError("Access forbidden: 403"));
    }
    if (error?.response?.status === 401) {
      return store.dispatch(logOut());
    }
    if (error.response && error.response.status === 400) {
      return Promise.reject(error);
    }
    if (error.response && error.response.status >= 500) {
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

const axiosNew = axios.create({
  baseURL: process.env.REACT_APP_API_URL_1
});

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export { axios, axiosNew };
